import { FC } from 'external/react'

import useParent from 'context/parent-context/hook'
import FormTextfield from 'components/FormTextfield'
import FormTextArea from 'components/FormTextArea'

type SupportFormProps = {
	errors: any
}

const SupportForm: FC<SupportFormProps> = props => {

	const {errors} = props

	const {supportForm: support, update} = useParent()

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: support[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e) => {
				update({supportForm: {[fieldName]: {$set: e.target.value}}})
			}
		}
	}
	return (
		<form className='d-flex flex-column flex-grow-1' autoComplete='on'>
			<FormTextfield controlProps={{autoComplete: 'name'}} {...createFieldProps('Nombre', 'name', 25)} />
			<FormTextfield controlProps={{autoComplete: 'email'}} {...createFieldProps('Correo', 'email', 25)} />
			<FormTextfield controlProps={{autoComplete: 'phone'}} {...createFieldProps('Teléfono', 'phone', 15)} />
			<FormTextArea className='d-flex flex-grow-1 flex-column' controlProps={{rows: 16, className: 'form-control flex-grow-1', style:{resize: 'none'}}} {...createFieldProps('Mensaje', 'message')} />
        </form>
	)
;
};

export default SupportForm
